import { Stack } from '@mui/material';
import { styled } from '@mui/system';

export const ContentContainer = styled(Stack)({
  padding: '25px 24px',
  width: '100%',
});
